import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CommonFunctionsService } from '../../providers/Global/commonFunctions.service';

import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

import { DropzoneDirective, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';

import { SearchMusicsComponent } from '../../components/searchmusics/searchMusics.component';

import { DropzoneService } from '../../providers/Import/dropzone.service';
import { AuthentificationService } from '../../providers/Global/authentification.service';
import { DataPassService } from '../../providers/Global/dataPass.service';

import { Countries } from '../../ressources/variables/countries';

import { Globals } from '../../ressources/variables/globals';

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.scss']
})
export class ImportComponent implements OnInit, OnDestroy, AfterViewInit {

  activatedRouteSub;

  permissions: Array<string> = [];

  config: DropzoneConfigInterface;

  @ViewChild(DropzoneDirective, {static: true}) directiveRef?: DropzoneDirective;
  @ViewChild('myDrop') myDrop;
  @ViewChild('soundType') soundType;

  allUploaded = false;

  configTable;
  winmediaData;
  proprietes;
  categories;
  genresAssociation;
  stationWithGenresAssociation;

  // Trier les pays par ordre alphabétique du nom français
  countriesJSON = [...Countries].sort((a, b) => {
    const nameA = a.translations.fra.common.toLowerCase();
    const nameB = b.translations.fra.common.toLowerCase();
    return nameA.localeCompare(nameB, 'fr');
  });

  countries = this.countriesJSON.map((v, index) => {
    return {
      id: index,
      label: v.translations.fra.common
    };
  });
  // countries = Countries.map(v => v.translations.fra.common);

  errorInit = false;
  initFolder = false;
  initConfig = false;
  initProprietes = false;
  initCategories = false;
  initGenresAssociation = false;
  initStationWithGenresAssociation = false;
  initWinmedia = false;

  serverEndpoint = Globals.serverEndpoint;

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private CF: CommonFunctionsService,
              private dropzoneService: DropzoneService,
              private authentificationService: AuthentificationService,
              private bottomSheet: MatBottomSheet,
              private iconRegistry: MatIconRegistry,
              private sanitizer: DomSanitizer,
              private dataPassService: DataPassService) {
    iconRegistry.addSvgIcon('forbidden', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/forbidden.svg'));
    this.config = this.dropzoneService.config;
    this.permissions = this.authentificationService.permissionsSource.getValue();
  }

  ngOnInit() {
    this.dropzoneService.files = [];
    this.activatedRouteSub = this.activatedRoute.paramMap.subscribe(params => {
      if (this.permissions.includes('access')) {
        this.dropzoneService.createFolders()
          .then(res => {
            console.log(res);
            if (res === true) {
              console.log('Success');
              this.initFolder = true;
            } else {
              console.error('Error createFolders');
              this.errorInit = true;
            }
          })
          .catch(err => console.error(err));
        this.dropzoneService.getConfigTable()
          .then(res => {
            console.log(res);
            this.configTable = res;
            this.dropzoneService.setLowBitrateAllowed(!!res.low_bitrate_allowed);
            this.updateDropzoneMessageElement();
            this.initConfig = true;
          })
          .catch(err => {
            console.error(err);
            this.errorInit = true;
          });
        this.dropzoneService.getProprietes()
          .then(res => {
            console.log(res);
            this.proprietes = res;
            this.initProprietes = true;
          })
          .catch(err => {
            console.error(err);
            this.errorInit = true;
          });
        this.dropzoneService.getCategories()
          .then(res => {
            console.log(res);
            this.categories = res;
            this.initCategories = true;
          })
          .catch(err => {
            console.error(err);
            this.errorInit = true;
          });
        this.dropzoneService.getGenresAssociation()
          .then(res => {
            console.log(res);
            this.genresAssociation = res;
            this.initGenresAssociation = true;
          })
          .catch(err => {
            console.error(err);
            this.errorInit = true;
          });
        this.dropzoneService.getStationWithGenresAssociation()
          .then(res => {
            console.log(res);
            this.stationWithGenresAssociation = res;
            this.initStationWithGenresAssociation = true;
          })
          .catch(err => {
            console.error(err);
            this.errorInit = true;
          });
        this.dropzoneService.getWinmediaData()
          .then(res => {
            console.log(res);
            this.winmediaData = res;
            this.initWinmedia = true;
          })
          .catch(err => {
            console.error(err);
            this.errorInit = true;
          });
      }
    });
  }

  ngAfterViewInit() {
    console.log(this.myDrop.nativeElement);
  }

  /**
   * Dropzone.js génère son message par défaut au montage à partir de dictDefaultMessage
   * et ne le met pas à jour tout seul si la config change ensuite (ex: réponse async de
   * getConfigTable). On corrige donc directement le texte déjà rendu dans le DOM.
   */
  private updateDropzoneMessageElement() {
    const button = this.myDrop && this.myDrop.nativeElement
      ? this.myDrop.nativeElement.querySelector('.dz-message .dz-button')
      : null;
    if (button) {
      button.innerHTML = this.config.dictDefaultMessage;
    }
  }

  ngOnDestroy() {
    this.activatedRouteSub.unsubscribe();
  }

  sendFiles() {
    console.log('Upload');
    this.dataPassService.import_files = this.dropzoneService.files;
    this.dataPassService.import_configTable = this.configTable;
    this.dataPassService.import_winmediaData = this.winmediaData;
    this.dataPassService.import_proprietes = this.proprietes;
    this.dataPassService.import_categories = this.categories;
    this.dataPassService.import_genres_association = this.genresAssociation;
    this.dataPassService.import_station_with_genres_association = this.stationWithGenresAssociation;
    this.dataPassService.import_countries = this.countries;
    this.dataPassService.import_countriesJSON = this.countriesJSON;
    /* soundType._selectedIndex : 0 Musiques / 1 Sons */
    if (this.permissions.includes('access' && 'import_files' && 'import_sons') && this.soundType && this.soundType._selectedIndex === 1) {
      this.router.navigate(['tableSons']).then(res => {
        console.log(res);
      });
    } else {
      this.router.navigate(['table']).then(res => {
        console.log(res);
      });
    }
  }

  dropzoneOnSending(): void {
    this.allUploaded = false;
  }

  removeFile(event) {
    /* A faire : retirer dans files, waveform (à voir si bloquant et dans mysql) */
    console.log(event.upload.filename + ' removed...');
  }

  dropzoneOnUploadComplete(args: any): void {
    console.log('onUploadComplete:', args);
    const metadata = {};
    if (args.xhr && args.xhr.response) {
      const responseJSON = JSON.parse(args.xhr.response);
      const forbidden = ['undefined', 'unknown', 'inconnu', 'piste', 'track', 'flac', 'mp3'];
      if (responseJSON.common
        && responseJSON.common.title && responseJSON.common.title !== ''
        && responseJSON.common.artist && responseJSON.common.artist !== ''
        && responseJSON.common.album && responseJSON.common.album !== '') {
        if (responseJSON.common.fromDeezer || (
          !this.contains(responseJSON.common.title, forbidden)
            && !this.contains(responseJSON.common.artist, forbidden)
            && !this.contains(responseJSON.common.album, forbidden)
          )) {
          metadata['title'] = responseJSON.common.title;
          metadata['artist'] = responseJSON.common.artist;
          metadata['album'] = responseJSON.common.album;
          metadata['isrc'] = Array.isArray(responseJSON.common.isrc)
            ? (responseJSON.common.isrc.length > 0 ? responseJSON.common.isrc[0] : null)
            : (responseJSON.common.isrc ?? null);
          metadata['cover_url'] = responseJSON.common.cover_url;
        }
      }
    }
    args.previewElement.classList.add('custom-preview');
    console.log(args.upload.filename, args.status);
    if (args.status === 'success') {
      this.dropzoneService.addFile(args.upload.filename, metadata);
    }
  }

  dropzoneOnUploadQueuecomplete(args: any): void {
    this.allUploaded = true;
    console.log(args);
    console.log(this.dropzoneService.files);
  }

  logout() {
    this.authentificationService.logout()
      .then(res => {
        console.log(res);
        this.router.navigate(['']).then(r => {
          console.log(r);
        });
      })
      .catch(err => {
        console.log(err);
        this.router.navigate(['']).then(r => {
          console.log(r);
        });
      });
  }

  searchMusics() {
    const bottomSheetRef = this.bottomSheet.open(SearchMusicsComponent, {
      data: { folderName: this.dropzoneService.folderName }
    });

    bottomSheetRef.afterDismissed().toPromise()
      .then(() => {
        console.log(this.dataPassService.searchMusics_result);
        for (const result of this.dataPassService.searchMusics_result) {
          let cover_url = '';
          if (result.deezerData.album && (result.deezerData.album.cover_xl || result.deezerData.album.cover_big)) {
            if (result.deezerData.album.cover_xl) {
              cover_url = result.deezerData.album.cover_xl ?? '';
            } else {
              cover_url = result.deezerData.album.cover_big ?? '';
            }
          }
          const mockFile = {
            name: result.name,
            size: result.size,
            type: 'audio/x-flac',
            accepted: true,
            processing: true,
            preview: 'file',
            status: 'success',
            upload: {
              filename: result.name,
              bytesSent: result.size,
              progress: 100,
              total: result.size
            },
            xhr: {
              response: JSON.stringify({
                common: {
                  title: result.deezerData.title.replace(/"/gi, ''),
                  artist: result.deezerData.artist.name.replace(/"/gi, ''),
                  album: result.deezerData.album.title.replace(/"/gi, ''),
                  isrc: result.deezerData.isrc ?? null,
                  cover_url: cover_url,
                  fromDeezer: true
                }
              })
            }
          };
          const displayCover = result.cover ? `${this.serverEndpoint}/pictureOfCover?filename=${this.CF.escapeSpecialsURL(result.cover.replace(/\+/gi, '%2B'))}&folder=${this.dropzoneService.folderName}` : 'assets/img/defLoad.png';
          this.myDrop.nativeElement.dropzone.displayExistingFile(mockFile, displayCover);
        }
        this.dataPassService.searchMusics_result = [];
      });
  }

  contains(target, pattern) {
    const lowerTarget = target.toLowerCase();
    return pattern.some((word) => lowerTarget.includes(word.toLowerCase()));
  }

}
